
import { defineComponent } from "vue";
import { IEnrollmentChargesModel } from "@/interfaces/modules";
import EnrollmentChargesService from "@/api/Collection/EnrollmentChargesService";
import IndividualEnrollmentService from "@/api/Enrollment/IndividualEnrollmentService";
import type { IIndividualEnrollmentModel } from "@/interfaces/modules";
import store from "@/store";

export default defineComponent({
  name: "EnrollmentChargeContent",
  props: ['record'],
  data() {
    return {
      enrollments: [] as IIndividualEnrollmentModel[],
      form: {
        loading: true,
        dialog: false,
        valid: false,
        wasValidated: false,
        record: {} as IEnrollmentChargesModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "SequenceId", label: "Referencia de pago", sortable: true },
          { key: "Concept", label: "Concepto", sortable: true },
          { key: "Quantity", label: "Cantidad", sortable: true },
          { key: "Amount", label: "Valor", sortable: true },
          { key: "Balance", label: "Saldo", sortable: true },
          { key: "CollectionDate", label: "Fecha de cobro", sortable: true },
          { key: "DueDate", label: "Fecha de vencimiento", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IEnrollmentChargesModel[],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      const q = this.table.filters.search?.toLowerCase() || "";
      return q
        ? this.table.records.filter((item: IEnrollmentChargesModel) =>
          [item.Concept, item.Amount, item.Balance]
            .filter(Boolean)
            .some((v) => String(v).toLowerCase().includes(q))
        )
        : this.table.records;
    },
    rows(): number {
      return this.table.records?.length || 0;
    },
  },
  async mounted() {
    await this.load();
    this.enrollments = await IndividualEnrollmentService.GetEnrollments();
  },
  methods: {
    async load() {
      this.table.loading = true;
      if (this.record.Id > 0)
        this.table.records = await EnrollmentChargesService.GetEnrollmentCharges({ EnrollmentId: this.record.Id } as any);
      this.table.loading = false;
    },
    async edit(data: IEnrollmentChargesModel) {
      this.form.record = await EnrollmentChargesService.GetEnrollmentChargeById({ Id: data.Id } as any);

      if (this.form.record.CollectionDate)
        this.form.record.CollectionDate = this.form.record.CollectionDate.substring(0, 10);

      if (this.form.record.DueDate)
        this.form.record.DueDate = this.form.record.DueDate.substring(0, 10);

      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await EnrollmentChargesService.PostEnrollmentCharge(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });
      this.load();
    },
  },
});
